module.exports = __webpack_public_path__ + "static/media/office15.20be3d10.jpg";